module.exports = __webpack_public_path__ + "media/images/app/how-it-works/rent-by-the-day-2bb5d1e4e22cca0fc0f2b619b54be195.webp";